import { useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";

//context
import context from "../../store/context";

import DateConverter from "../DateConverter";
import TimeDifference from "../TimeDifference";
import SaveUnsave from "../Buttons/SaveUnsave";

//icons
import CalendarIcon from "../icons/Calendar";

const TenderCard = ({
  title,
  openingDate,
  closingDate,
  createdAt,
  id,
  status,
  isSavedDB,
  currentPath,
  alternativeOpeningDate,
  alternativeClosingDate,
  publishedOn,
}) => {
  const currentTime = new Date();

  const { setPrevRoute } = useContext(context);

  const navigate = useNavigate();

  const location = useLocation();

  const telegramPage =
    location.pathname.startsWith("/latest-tenders/telegram") ||
    location.pathname.startsWith("/myfeed/telegram");
  const telegramDetail = location.pathname.startsWith("/tender/telegram");

  const openDetailPage = () => {
    setPrevRoute(telegramDetail ? "/latest-tenders/telegram" : currentPath);

    if (telegramPage) {
      navigate(`/tender/telegram/${id}`);
    } else {
      navigate(`/tender/${id}`);
    }
  };

  const redirect = () => {
    navigate(telegramPage ? "/login/telegram" : "/login");
  };

  const userToken = localStorage.getItem("token") || telegramPage || telegramDetail;
  const notAUser = "Login or Subscribe";
  const isOpen = Number(status) === 1;

  return (
    <div className="w-full flex flex-col gap-3 bg-white rounded-2xl py-4 px-5 border border-gray-200/70 shadow-[0_2px_10px_rgba(61,89,132,0.08)] text-[#3d5984]">
      <button
        onClick={openDetailPage}
        className="w-full flex flex-col items-start gap-3 text-start"
      >
        <div className="w-full flex flex-col items-start gap-2">
          <h1 className="text-sm sm:text-base font-semibold leading-snug">
            {title}
          </h1>
          <span
            className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-semibold ring-1 ${
              isOpen
                ? "bg-green-50 text-green-600 ring-green-600/20"
                : "bg-red-50 text-red-500 ring-red-500/20"
            }`}
          >
            <CalendarIcon styles="w-3.5 h-3.5" />
            {isOpen ? "BIDDING OPEN" : "BIDDING CLOSED"}
          </span>
        </div>

        <div className="w-full h-px bg-gray-100" />

        <div className="flex flex-col gap-2 text-xs sm:text-sm items-start w-full">
          <div className="flex items-start gap-2">
            <h1 className="font-medium text-[#3d5984]/60 min-w-max">
              Bid Closing Date:
            </h1>

            {userToken ? (
              alternativeClosingDate ? (
                <span className="text-start font-medium">
                  {alternativeClosingDate}{" "}
                </span>
              ) : closingDate ? (
                <DateConverter dateString={closingDate} />
              ) : (
                ""
              )
            ) : (
              <span>{notAUser}</span>
            )}
          </div>
          <div className="flex items-start gap-2">
            <h1 className="font-medium text-[#3d5984]/60 min-w-max">
              Bid Opening Date:
            </h1>

            {userToken ? (
              alternativeOpeningDate ? (
                <span className="text-start font-medium">
                  {alternativeOpeningDate}{" "}
                </span>
              ) : openingDate ? (
                <DateConverter dateString={openingDate} />
              ) : (
                ""
              )
            ) : (
              <span>{notAUser}</span>
            )}
          </div>

          <div className="flex items-start gap-2">
            <h1 className="font-medium text-[#3d5984]/60 min-w-max">
              Published On:
            </h1>
            {userToken ? (
              publishedOn ? (
                publishedOn.map((publisher, index) => {
                  return (
                    <div
                      className="text-start flex items-start gap-2 font-medium"
                      key={publisher.source.id}
                    >
                      {index !== 0 && <span>,</span>}
                      <span>{publisher.source.name}</span>

                      <div className="flex">
                        <span>{`(`}</span>
                        <DateConverter dateString={publisher.published_at} />
                        <span>{`)`}</span>
                      </div>
                    </div>
                  );
                })
              ) : (
                ""
              )
            ) : (
              <span>{notAUser}</span>
            )}
          </div>
        </div>
      </button>
      <div className="flex flex-wrap items-center justify-between border-t border-t-gray-100 pt-3">
        <div className="flex items-center gap-2">
          <SaveUnsave
            navigate={redirect}
            isSavedDB={isSavedDB}
            id={id}
            currentPath={currentPath}
          />
        </div>
        <span className="italic text-xs sm:text-sm text-[#3d5984]/50">
          <TimeDifference currentTime={currentTime} dateString={createdAt} />
        </span>
      </div>
    </div>
  );
};

export default TenderCard;
